module.exports = __webpack_public_path__ + "img/faq_after.e58ad68f.svg";